import Vue from 'vue'
import Router from 'vue-router'
import iView from 'iview'
import 'iview/dist/styles/iview.css';

Vue.use(Router)
Vue.use(iView)

const router = new Router({
  routes: [{
    path: '/root',
    name: 'root',
    component: resolve => require(['@/components/page/root'], resolve),
    children: [{
      path: 'view',
      name: 'view',
      component: resolve => require(['@/components/page/view'], resolve),
    }, ]
  },{
    path: "*",
    redirect: "/root/view"
   }]
});

router.beforeEach((to, from, next) => {
  iView.LoadingBar.start();
  next();
});

router.afterEach(route => {
  iView.LoadingBar.finish();
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js